import { AppState } from "../store";

export const selectNews = (state: AppState) => state.newsfeed.newsfeedData;

export const selectNewsFetchStatus = (state: AppState) =>
  state.newsfeed.newsfeedFetchStatus;

export const selectSingleNews = (state: AppState, slug: string) =>
  state.newsfeed.newsfeedData.find((news) => news.slug == slug);
